import React, { useState } from 'react';
import { List, NavMenu, Popover, Text } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getLocale, useIntl, useDispatch } from 'umi';
import { ENV, LANGUAGE_CN } from '@/pages/home/_config/config';
// import UnloadModal from '@/pages/home/pages/home/Explore/components/UnloadModal';
import VersionHistory from '../../VersionPopup/VersionHistory';
import CustomizeHomepage from '../../CustomizeHomepage';
import { storage } from '@/utils/utils';
import { DASHBOARD_GUIDE_HIDE } from '../../GuideModule/GuideDashboardBox';

export default function Help(props: any) {
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { list: helpList = [], defaultHelpUrl = '' } = props;
  // const [open, setOpen] = useState(false);
  const [versionVisible, setVersionVisible] = useState(false);
  const [ishomepage, setHomepage] = useState(false);
  // 帮助相关的下拉
  const [settingVisible, setSettingVisible] = useState(false);
  const dispatch = useDispatch();

  // const handleHelpMenuEvent = (eventName: string) => {
  //   if (eventName === 'feedback') {
  //     setOpen(true);
  //     return;
  //   }
  // };

  const handleOpenLink = (url: string, eventName?: string) => {
    // if (eventName == 'feedback') {
    //   handleHelpMenuEvent(eventName);
    //   return;
    // }

    if (eventName == 'onlineService') {
      url && window.open(url, '_self');
      return;
    }

    if (eventName === 'dashboardGuideBox') {
      dispatch({
        type: 'guide/showDashboardGuideModule',
        payload: true,
      });
      return;
    }

    // 这个暂时不能发布到线上，先屏蔽
    if (eventName === 'opinionGuideBox') {
      dispatch({
        type: 'guide/showOpinionGuideModule',
        payload: true,
      });
      return;
    }

    // 这个暂时不能发布到线上，先屏蔽pro
    // if (eventName === 'intelligenceGuideBox' && !['pro'].includes(ENV)) {
    if (eventName === 'intelligenceGuideBox') {
      dispatch({
        type: 'guide/showIntelligenceGuideModule',
        payload: true,
      });
      return;
    }

    url && window.open(url, '_target');
  };

  const nameKey = locale === LANGUAGE_CN ? 'text_cn' : 'text';
  const linkKey = locale === LANGUAGE_CN ? 'link_cn' : 'link';

  return (
    <>
      <NavMenu.Item>
        {/* 设置 */}
        <Popover
          visible={settingVisible}
          onVisibleChange={(visible) => setSettingVisible(visible)}
          placement="bottom-start"
          trigger="hover"
          overlayClassName="dba-nav-menu-overlay"
          overlay={
            <div className="settingdown">
              {helpList.map((curList: any, index: number) => (
                <div
                  key={`help-${index}`}
                  className={`${
                    index !== helpList.length - 1
                      ? 'item-gap-footer'
                      : 'item-gap-footer'
                  }`}
                >
                  <List
                    type="option"
                    className={`${curList.className ? curList.className : ''} ${
                      index !== 0 ? 'item-gap-top' : ''
                    } ${
                      index !== helpList.length - 1
                        ? 'item-gap-bottom'
                        : 'item-gap-bottom'
                    }`}
                  >
                    {curList.listTitle ? (
                      <span className="settingdown-title">
                        {curList.listTitle[nameKey] || curList.listTitle.text}
                      </span>
                    ) : null}
                    {curList.list?.map((item: any, innerIndex: number) => (
                      <List.Item
                        className="settingdown-item"
                        key={`help-${index}-${innerIndex}`}
                        onClick={() =>
                          handleOpenLink(
                            item[linkKey] || item.link,
                            item?.eventName,
                          )
                        }
                      >
                        <SvgIcon
                          type={item.icon}
                          className="settingdown-icon"
                        />
                        <Text className="settingdown-text">
                          {item[nameKey] || item.text}
                        </Text>
                        {item.isNew && (
                          <Text className="settingdown-new">NEW</Text>
                        )}
                      </List.Item>
                    ))}
                  </List>
                </div>
              ))}
              {/* 模拟历史版本入口 */}
              <List type="option">
                {/* <List.Item className='settingdown-item' onClick={() => { setHomepage(true) }}>
            <SvgIcon type="pencil-m" className='settingdown-icon' />
            <Text className='settingdown-text'>Customize Homepage</Text>
          </List.Item> */}
                <List.Item
                  className="settingdown-item"
                  onClick={() => {
                    setVersionVisible(true);
                  }}
                >
                  <SvgIcon type="book-m" className="settingdown-icon" />
                  <Text className="settingdown-text">
                    {formatMessage({ id: 'dbh_versionhistory_helptitle' })}
                  </Text>
                  {/* <Text className='settingdown-new'>NEW</Text> */}
                </List.Item>
              </List>
            </div>
          }
        >
          <div className="lay-nav-right dbh-nav-help">
            <SvgIcon type="question-circle" className="item-icon" style={{ width: '22px', height: '22px' }} />
          </div>
        </Popover>
      </NavMenu.Item>
      {/* <UnloadModal
        visible={open}
        close={() => {
          setOpen(!open);
        }}
      /> */}
      {versionVisible && (
        <VersionHistory
          visible={versionVisible}
          close={() => {
            setVersionVisible(false);
          }}
        />
      )}
      <CustomizeHomepage
        visible={ishomepage}
        close={() => {
          setHomepage(!ishomepage);
        }}
      />
    </>
  );
}
